import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Admin.css';

const AgentDashboardDemo: React.FC = () => {
  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>Agent Dashboard Demo</h1>
        <nav className="admin-nav">
          <Link to="/admin">Dashboard</Link>
          <Link to="/admin/orders">Orders</Link>
          <Link to="/admin/products">Products</Link>
          <Link to="/admin/reviews">Reviews</Link>
          <Link to="/admin/discounts">Discounts</Link>
          <Link to="/admin/agent-dashboard">Agent Demo</Link>
        </nav>
      </div>

      <div className="admin-section">
        <p>
          This demo embeds the static dashboard file from public/dashboard/agent-dashboard.html.
        </p>
        <p>
          <a href="/dashboard/agent-dashboard.html" target="_blank" rel="noreferrer">
            Open dashboard in a new tab
          </a>
        </p>
      </div>

      <div className="admin-section" style={{ padding: 0, overflow: 'hidden' }}>
        <iframe
          title="Agent Dashboard Demo"
          src="/dashboard/agent-dashboard.html"
          style={{ width: '100%', minHeight: '900px', border: 0 }}
        />
      </div>
    </div>
  );
};

export default AgentDashboardDemo;